import { Controller } from '@hotwired/stimulus'
import { navigateFrame } from '../../modules/table_navigation'

export default class extends Controller {
  static targets = ['field', 'select']

  update() {
    const [attr, value] = this.selectTarget.value.split(':')
    this.fieldTargets.forEach(field => {
      field.value = field.dataset.attribute === attr ? value : ''
    })
    navigateFrame(this.element.closest('form'))
  }
}
